import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Exit.svg",
  "use": "Exit.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Exit.svg\"><path d=\"M24.8563,9.0915a23.9807,23.9807,0,0,0,0,45.7959A2.437,2.437,0,0,0,28,52.55V11.429A2.437,2.437,0,0,0,24.8563,9.0915Zm14.2875,0A2.4371,2.4371,0,0,0,36,11.429V52.55a2.4371,2.4371,0,0,0,3.1438,2.3376,23.9807,23.9807,0,0,0,0-45.7959Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol